import { getExcelExportItems } from './exports/getExcelExportItems';
import { getPdfExportItems } from './exports/getPdfExportItems';

export const getCommandBarItems = (
  municipality,
  translator,
  createHearing,
  rerouteToSelectedHearing,
  isCreatingHearing,
  canDeleteHearing,
  isHearingInCreatedStatus,
  deleteHearing,
  canDownloadReport,
  downloadReport,
  downloadZip,
  canEditHearing,
  canDownloadFullReport,
  copyHearingLink,
  canCopyHearingLink,
  canDownloadUserReport,
  canDownloadHearingResponseReport,
  didCopyHearingLink,
) => {
  const {
    disableSubmenu: disablePdfSubmenu,
    commandBarItems: pdfExportItems,
  } = getPdfExportItems(
    municipality,
    translator,
    downloadReport,
    canDownloadReport,
    canDownloadFullReport,
    buttonStyles,
  );

  const {
    disableSubmenu: disableExcelSubmenu,
    commandBarItems: excelExportItems,
  } = getExcelExportItems(
    municipality,
    translator,
    downloadReport,
    canDownloadReport,
    canDownloadUserReport,
    canDownloadHearingResponseReport,
    buttonStyles,
  );
  return [
    {
      key: 'createHearing',
      name: translator('pages.createHearing.headerCreate'),
      iconProps: {
        iconName: 'Add',
      },
      onClick: createHearing,
      buttonStyles,
      disabled: isCreatingHearing,
    },
    {
      key: 'editHearing',
      name: translator('pages.createHearing.editHearing'),
      iconProps: {
        iconName: 'Share',
      },
      disabled: !canEditHearing,
      subMenuProps: {
        items: [
          {
            key: 'editHearingMetaData',
            name: translator('pages.createHearing.editHearingMetaData'),
            iconProps: {
              iconName: 'CalendarSettings',
            },
            onClick: () => rerouteToSelectedHearing(1),
          },
          {
            key: 'editHearingData',
            name: translator('pages.createHearing.editHearingData'),
            iconProps: {
              iconName: 'EditNote',
            },
            onClick: () => rerouteToSelectedHearing(2),
            disabled: isHearingInCreatedStatus,
          },
          {
            key: 'editHearingInvitees',
            name: translator('pages.createHearing.editHearingInvitees'),
            iconProps: {
              iconName: 'EditContact',
            },
            onClick: () => rerouteToSelectedHearing(3),
            disabled: isHearingInCreatedStatus,
          },
        ],
      },
      buttonStyles,
    },
    {
      key: 'deleteHearing',
      name: translator('pages.createHearing.deleteHearing'),
      iconProps: {
        iconName: 'Delete',
      },
      disabled: !canDeleteHearing,
      onClick: deleteHearing,
      buttonStyles,
    },
    {
      key: 'exportPdf',
      name: translator('pages.createHearing.downloadPdf'),
      iconProps: { iconName: 'PDF' },
      disabled: disablePdfSubmenu,
      subMenuProps: {
        items: pdfExportItems,
      },
      buttonStyles,
    },
    {
      key: 'exportExcel',
      name: translator('pages.createHearing.downloadExcel'),
      iconProps: { iconName: 'PDF' },
      disabled: disableExcelSubmenu,
      subMenuProps: {
        items: excelExportItems,
      },
      buttonStyles,
    },
    {
      key: 'downloadZip',
      name: translator('pages.createHearing.downloadZip'),
      iconProps: {
        iconName: 'ZipFolder',
      },
      disabled: !canDownloadReport,
      onClick: downloadZip,
      buttonStyles,
    },
    {
      key: 'copyExternalHearingLink',
      name: didCopyHearingLink
        ? translator('pages.createHearing.didCopyHearingLink')
        : translator('pages.createHearing.copyHearingLink'),
      iconProps: {
        iconName: didCopyHearingLink ? 'Accept' : 'Copy',
      },
      onClick: copyHearingLink,
      disabled: !canCopyHearingLink,
      buttonStyles,
    },
  ];
};

const buttonStyles = {
  root: {
    backgroundColor: '#FAFAFA',
  },
  rootDisabled: {
    backgroundColor: '#FAFAFA',
  },
};
